import { UPDATE_CANCELLATION_DATE } from '../../constants/actions/policy';

export function updateCancellationDate(payload) {
    return {
        type: UPDATE_CANCELLATION_DATE,
        payload,
    };
}
